<script>
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
export default {
  name: "VideoSection",
  methods: {
    once(el, event, fn, opts=null) {
        let onceFn = function (e) {
            el.removeEventListener(event, onceFn)
            fn.apply(this, arguments)
        }
        el.addEventListener(event, onceFn, opts)
        return onceFn
    },
    desktopVideo() {
        const video = document.getElementById('v1')
        let src = video.currentSrc || video.src

        this.once(document.documentElement, 'touchstart', function (e) {
            video.play()
            video.pause()
        })


        let tl = gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
                trigger: '.video-pin',
                pin: '.video-pin',
                start: 'center center',
                end: '+=3000',
                scrub: 0.5
            }
        })

        this.once(video, 'loadedmetadata', () => {
            tl.fromTo(
                video,
                {
                    currentTime: 0
                },
                {
                    currentTime: (video.duration - 0.05) || 0.95
                }
            )
        })
        let self = this
        setTimeout(function () {
            if (window['fetch']) {
                fetch(src)
                    .then((response) => response.blob())
                    .then((response) => {
                        self.once(document.documentElement, 'touchstart', function (e) {
                            video.play()
                            video.pause()
                        })
                    })
            }
        }, 1000)
    },
    mobileVideo() {
        const video = document.getElementById('v2')
        let src = video.currentSrc || video.src

        this.once(document.documentElement, 'touchstart', function (e) {
            video.play()
            video.pause()
        })


        let frameNumber = 0
        let tl = gsap.timeline({
            defaults: { duration: 1 },
            scrollTrigger: {
                trigger: '.video-pin',
                start: 'center center',
                end: '+=3000',
                scrub: 0.5
            }
        })

        this.once(video, 'loadedmetadata', () => {
            tl.fromTo(
                video,
                {
                    currentTime: 0
                },
                {
                    currentTime: (video.duration - 0.05) || 0.95
                }
            )
        })
        let self = this
        setTimeout(function () {
            if (window['fetch']) {
                fetch(src)
                    .then((response) => response.blob())
                    .then((response) => {
                       self.once(document.documentElement, 'touchstart', function (e) {
                            video.play()
                            video.pause()
                        })
                    })
            }
        }, 1000)
    }
  },
  mounted() {
    gsap.registerPlugin(ScrollTrigger)
    this.desktopVideo()
    this.mobileVideo()
  }
}
</script>
<template>
  <div class="video-pin text-center">
    <div class="row justify-content-center scroll-text">
      <div class="col-60 col-lg-35 d-flex justify-content-evenly">
            <div class="chevron-container">
              <div class="chevron"></div>
              <div class="chevron"></div>
              <div class="chevron"></div>
            </div>
            <h2 class="alfa">
                Scroll down to see <br><strong>Sport.Video in action</strong>
            </h2>
            <div class="chevron-container">
              <div class="chevron"></div>
              <div class="chevron"></div>
              <div class="chevron"></div>
            </div>
      </div>
    </div>
    <article class="section video-highlight-section">
        <div class="container px-0 px-sm-1">
            <div class="video-wrap-outer position-relative">
                <div class="video-wrap position-relative">
                    <div class="video-wrap-inner">
                        <video id="v1" tabindex="0" src="/static/videos/vid_compressed_cut.mp4" autobuffer="autobuffer" preload="preload" playsinline="true" webkit-playsinline="true" poster="/static/images/vid5_poster.jpg">
                        </video>
                    </div>
                </div>

                <div class="mockup-wrap-outer position-absolute">
                    <img
                        src="/static/images/iphone-mockup.png"
                        class="img-fluid position-relative"
                        alt=""
                    />
                    <div class="mockup-wrap-inner position-absolute">
                        <div class="mockup-video">
                            <video id="v2" tabindex="0" src="/static/videos/vid_mob.mp4" autobuffer="autobuffer" preload="preload" playsinline="true" webkit-playsinline="true" poster="/static/images/vid5_poster.jpg">
                        </video>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </article>
  </div>
</template><style lang="scss" scoped>
@import '../../sass/abstracts/_mixins.scss';
$base: 0.6rem;

.chevron-container {
 display: flex;
 justify-content: center;
 width: 5%;
}

.chevron {
  position: absolute;
  width: $base * 3.5;
  height: $base * 0.8;
  opacity: 0;
  transform: scale(0.3);
  animation: move-chevron 3s ease-out infinite;
}

.chevron:first-child {
  animation: move-chevron 3s ease-out 1s infinite;
}

.chevron:nth-child(2) {
  animation: move-chevron 3s ease-out 2s infinite;
}

.chevron:before,
.chevron:after {
 content: '';
 position: absolute;
 top: 0;
 height: 100%;
 width: 50%;
 background: #2c3e50;
}

.chevron:before {
 left: 0;
 transform: skewY(30deg);
}

.chevron:after {
 right: 0;
 width: 50%;
 transform: skewY(-30deg);
}

@keyframes move-chevron {
 25% {
  opacity: 1;
	}
 33.3% {
  opacity: 1;
  transform: translateY($base * 3.8);
 }
 66.6% {
  opacity: 1;
  transform: translateY($base * 5.2);
 }
 100% {
  opacity: 0;
  transform: translateY($base * 8) scale(0.5);
 }
}
.video-highlight-section {
  @include media-breakpoint-up(lg) {
    scale: 0.75;
    padding-bottom: 0;
  }
}
.scroll-text {
  @include media-breakpoint-up(lg) {
    padding-top: 70px;
    margin-bottom: -30px;
  }
}
.video-pin {
  @include media-breakpoint-down(md) {
    height: 120% !important;
    max-height: 120% !important;
  }
}
.mockup-wrap-outer {
    max-width: 46rem;
    left: 50%;
    width: 100%;
    transform: translateX(-50%);
    bottom: -8rem;
    z-index: 10;
    @include media-breakpoint-down(md) {
        bottom: -7rem;
        width: 92%;
    }
    @include media-breakpoint-down(sm) {
        bottom: -5rem;
        width: 92%;
    }

    img {
        z-index: 2;
    }

    .mockup-wrap-inner {
        width: 100%;
        height: 100%;
        inset: 0;
        overflow: hidden;
        border-radius: 5.3rem;
        z-index: 1;
        padding: 0.6rem;

        @include media-breakpoint-down(sm) {
            border-radius: 2.5rem;
            padding: 0.4rem;
        }

        @media (max-width: 400px) {
            transform: scale(1.02);
        }

        @include media-breakpoint-only(sm) {
            border-radius: 3rem;
        }
    }

    .mockup-video {
        width: 100%;
        height: 100%;
        position: relative;

        video {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }
}
.video-wrap {
    border: 0.6rem solid #e9e9e9;
    border-radius: 1.7rem;
    overflow: hidden;
    width: 100%;
    height: auto;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    background-color: #e9e9e9;
    video {
        width: 100%;
        min-height: 100%;
        overflow: hidden;
    }
}

.video-wrap-inner {
    border-radius: 0.8rem;
    overflow: hidden;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
}

.video-wrap-outer::after {
    content: '';
    width: 100%;
    height: 30%;
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #fff 90%);

    @include media-breakpoint-down(md) {
        height: 50%;
    }
}
</style>